export interface RequestData<T, U> {
    url: string;
    method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
    objectToSend?: U;
    fileDescriptor?: string;
    fileToSend?: File;
    transform?: (data: any) => T;
}

export class ApiError extends Error {
    public error: string
    public code: string;
    public status: number;
    constructor(message: string, code: string, status: number) {
        super(message);
        this.error = message;
        this.code = code;
        this.status = status;
    }
}

export type RequestStatusSnackbarConfig = Partial<{
    showRequestSentSnackbar: boolean;
    showRequestSuccessSnackbar: boolean;
    showRequestErrorSnackbar: boolean;
}>